import { useEffect, useState } from "react";
import { navItems } from "@/mocks/doumanData";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50/80 backdrop-blur"
      }`}
    >
      <div className="px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-book-open-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading font-extrabold text-lg text-foreground-950">抖漫</span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="页面分区导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#download"
            className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            立即下载
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开导航菜单"
          aria-expanded={open}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-4">
          <nav className="flex flex-col py-2" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-md text-sm font-medium text-foreground-800 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#download"
            onClick={() => setOpen(false)}
            className="block text-center px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            立即下载
          </a>
        </div>
      )}
    </header>
  );
}